import React from 'react'
import { OptionedPreset } from 'services/api/entities/catalog/packages/common'
import { OnlyWithPresetsOrId } from '../eventPackage/package/common'
import { ProductPresetField } from '../ProductPresetField'
import OptionGroupWithItems from 'ui-shared/OptionGroupItems'
import { Box, Container } from '@mui/material'

type Props = {
  pkg?: OnlyWithPresetsOrId<OptionedPreset>
}

const PhysicalPackageReadonlyPresetsList: React.FC<Props> = ({ pkg }) => {
  return (
    <Container>
      <Box display="flex" flexDirection="column">
        {pkg &&
          typeof pkg !== 'number' &&
          pkg.presets.map((preset, index) => (
            <React.Fragment key={preset.id}>
              <h3>{`${index + 1}) \n`}Presets</h3>
              <ProductPresetField record={preset} />
              {preset.optionsFull.map((option, index) => (
                <OptionGroupWithItems
                  key={`physical_${option.id}`}
                  option={option}
                  index={index}
                />
              ))}
              {preset.upselling?.map((upselling, index) => (
                <Box marginLeft="1.5rem" key={`physical_${upselling.id}`}>
                  <h4>{`${index + 1}) \n`}Upselling </h4>
                  <ProductPresetField record={upselling} hasRatioMultiplier />
                </Box>
              ))}
            </React.Fragment>
          ))}
      </Box>
    </Container>
  )
}

export default PhysicalPackageReadonlyPresetsList
